import React from 'react';
import CapabilityQuestionsPageIndicator from './CapabilityQuestionsPageIndicator';
import StandardQuestionsPageIndicator from './StandardQuestionsPageIndicator';

function PageIndicator(props) {
  switch (props.page.type) {
    case 'standard-questions':
      return <StandardQuestionsPageIndicator {...props} />;
    default:
      return <CapabilityQuestionsPageIndicator {...props} />;
  }
}

export default PageIndicator;
